import React, { useState } from 'react';
import filter from './img/filter.svg';
import tia from './img/tia.png';
import trophy from './img/trophy.svg';
import line from './img/line.svg';
import { StudyGuideDiagnostic } from './study-guide-diagnostic/study-guide-diagnostic';
import { StudyGuideLesson } from './study-guide-lesson';
import { StudyGuideQuiz } from './study-guide-quiz';
import { StudyGuideMyGuide } from './study-guide-my-guide';
// import {StudyGuideMonitoring} from './study-guide-monitoring';
import { StudyGuideModalLegend } from './study-guide-modal-legend';
import { DashboardContent } from '@/layouts/dashboard';
import {
  GuideAbout,
  GuideAboutBg,
  GuideAboutBody,
  GuideAboutHeader,
  GuideAboutLine,
  GuideAboutSection,
  GuideAboutSectionBody,
  GuideAboutSectionDescription,
  GuideAboutSectionHeader,
  GuideAboutSectionImg,
  GuideAboutSectionList,
  GuideAboutSectionTitle,
  GuideAboutTitle
} from '@/components/custom/guide';
import { Button } from '@/components/ui/button';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';

export function StudyGuidePanorama(props) {
  const { uri } = props;

  const [showModal, setShowModal] = useState(false);

  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: '/guia-de-estudos',
        name: 'Guia de estudos',
        isActive: false
      },
      {
        route: uri,
        name: 'Como o Guia funciona',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <GuideAbout>
        <GuideAboutHeader>
          <GuideAboutTitle>Como seus interesses influenciam o seu Guia de Estudos?</GuideAboutTitle>

          <Dialog>
            <DialogTrigger asChild>
              <Button variant="outline">Legenda</Button>
            </DialogTrigger>

            <StudyGuideModalLegend
              show={showModal}
              onClose={() => setShowModal(false)}
            />
          </Dialog>
        </GuideAboutHeader>

        <GuideAboutBody>
          <GuideAboutBg>
            <GuideAboutLine
              src={line}
              alt="linha"
            />
          </GuideAboutBg>

          <GuideAboutSection>
            <GuideAboutSectionHeader>
              <GuideAboutSectionImg
                src={filter}
                alt="filtro"
              />
              <GuideAboutSectionTitle>Todas as suas interações nos são constantemente coletadas pela nossa Tecnologia de Inteligência Artificial</GuideAboutSectionTitle>
            </GuideAboutSectionHeader>

            <GuideAboutSectionBody>
              <GuideAboutSectionDescription>Todas as aulas que você iniciou e quizzes que respondeu são levados em consideração para personalizar o seu guia.</GuideAboutSectionDescription>
              <GuideAboutSectionList>
                <StudyGuideLesson />
                <StudyGuideQuiz />
              </GuideAboutSectionList>
            </GuideAboutSectionBody>
          </GuideAboutSection>

          <GuideAboutSection>
            <GuideAboutSectionHeader>
              <GuideAboutSectionImg
                src={tia}
                alt="T.I.A"
              />
              <GuideAboutSectionTitle>A T.I.A, nossa IA, cuidadosamente analisa e organiza suas preferências para criar o Guia de Estudos ideal para você, então...</GuideAboutSectionTitle>
            </GuideAboutSectionHeader>

            <GuideAboutSectionBody>
              <GuideAboutSectionDescription>As interações no seu próprio Guia de Estudos e as monitorias que você participa também são essenciais para a T.I.A entender como você aprende</GuideAboutSectionDescription>
              <GuideAboutSectionList>
                <StudyGuideMyGuide />
                {/* <StudyGuideMonitoring /> */}
              </GuideAboutSectionList>
            </GuideAboutSectionBody>
          </GuideAboutSection>

          <GuideAboutSection>
            <GuideAboutSectionHeader>
              <GuideAboutSectionImg
                src={trophy}
                alt="troféu"
              />
              <GuideAboutSectionTitle>... traçamos uma trilha com conteúdos personalizados e atualizados semanalmente para te auxiliar.</GuideAboutSectionTitle>
            </GuideAboutSectionHeader>

            <GuideAboutSectionBody>
              <GuideAboutSectionDescription>Nas provas diagnósticas, você mostra suas forças e seus pontos de melhoria para que a T.I.A possa ajustar seu Guia às suas necessidades.</GuideAboutSectionDescription>
              <GuideAboutSectionList>
                <StudyGuideDiagnostic />
              </GuideAboutSectionList>
            </GuideAboutSectionBody>
          </GuideAboutSection>
        </GuideAboutBody>
      </GuideAbout>
    </DashboardContent>
  );
}
